import { render } from "./VtoProduct.vue?vue&type=template&id=a9885816"
import script from "./VtoProduct.vue?vue&type=script&lang=js"
export * from "./VtoProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__